export const project = {
  "projectName":"Sensiz Olmaz Sessiz Olmaz"
};